import React, { useState } from 'react'
import { AddParkingPricePeriodComponent } from '../Components/ParkingPricePeriod/AddParkingPricePeriodComponent';
import { AllParkingPricePeriodComponent } from '../Components/ParkingPricePeriod/AllParkingPricePeriodComponent';
import { EditParkingPricePeriodComponent } from '../Components/ParkingPricePeriod/EditParkingPricePeriodComponent';
import { ParkingPeriodCategoryComponent } from '../Components/Category/ParkingPeriodCategoryComponent';
// ======================================================================
export const ParkingPricePeriod = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "Category" ?
                <ParkingPeriodCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => {
                        setCategoryId(id);
                        setCategoryTitle(title);
                        setView("All");
                    }}
                />
                : <></>}

            {view == "All" ?
                <AllParkingPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    categoryTitle={categoryTitle}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onAddClick={() => setView("Add")}
                    onEdit={(id) => { setId(id); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); }}
                    onBackClick={()=> setView("Category")}
                    /> : <></>}
            {view === "Add" ?
                <AddParkingPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    categoryTitle={categoryTitle}
                    rowInserted={() => {
                        setView("All"); if (currentPage != 1)
                            setCurrentPage(1);
                        else
                            setVersion(version + 1);
                    }}
                    cancelInsert={() => { setView("All"); }} />
                : <></>}
            {view === "Edit" ?
                <EditParkingPricePeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={id}
                    rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                    cancelEdit={() => { setView("All"); }} />
                :
                <></>}

           
        </>
    )
}
